import { LitElement, html, css } from 'lit'
import { property, customElement } from 'lit/decorators.js'
import type { PopoverAttributes } from 'zaptic-popover'

@customElement('zaptic-popover')
export class Popover extends LitElement implements PopoverAttributes {
    @property({ type: Boolean, reflect: true })
    above = false

    static styles = css`
        :host {
            display: block;
            height: 0;
            overflow: visible;
        }

        .inner {
            width: 100%;
            border: 1px solid var(--grey5);
            background: white;
            border-radius: 5px;
            margin: 0;
            padding: 0;
            z-index: 100;
            position: relative;
            box-sizing: border-box;
            margin-top: 5px;
        }

        :host([above]) > .inner {
            transform: translate(0, -100%);
        }

        :host([hidden]) {
            display: none;
        }
    `

    render() {
        return html`<div part="inner" class="inner">
            <slot><span>No content</span></slot>
        </div>`
    }
}
